
import { defineComponent, PropType, ref, watch } from 'vue';
import { stationsGetMapStation } from '@/services/StationsService';
import useSimpleStore from '@/helpers/useSimpleStore';

type StationPrice = {
  price: number;
  fuel: {
    code: string;
  };
};

type PopupContent = {
  name: string;
  address: string;
  prices: StationPrice[];
};

export default defineComponent({
  name: 'StationMapPopup',
  emits: ['close'],
  props: {
    stationId: {
      type: String as PropType<string | null>,
      required: false,
      default: null,
    },
    isLinkEnabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit, expose }) {
    const content = ref<PopupContent | null>(null);

    let requestId = 0;

    const { isRequestInProgress, errorMessage, errorText, execute } = useSimpleStore(async (id?: string | null) => {
      if (!id) {
        content.value = null;
        return;
      }

      const currentRequestId = ++requestId;
      content.value = null;
      const result = await stationsGetMapStation({ id });

      if (currentRequestId !== requestId) {
        return;
      }

      if (!result.station) {
        content.value = null;
        return;
      }

      content.value = {
        name: result.station.name ?? 'Станция не найдена',
        address: result.station.address ?? '-',
        prices: result.station.prices ?? [],
      };
    }, 'Ошибка получения данных о станции');

    watch(
      () => props.stationId,
      (stationIdValue) => {
        execute(stationIdValue);
      },
      { immediate: true },
    );

    const close = () => {
      content.value = null;
      emit('close');
    };

    expose({ close });

    return {
      content,
      isRequestInProgress,
      errorMessage,
      errorText,
      close,
    };
  },
});
